import ModuleConfig from '../Config';

const actions = ModuleConfig.Actions;
const endpoints = ModuleConfig.Endpoints;
const ShipmentManifest = ModuleConfig.Structures.ShipmentManifest;
const CRUDActions = ModuleConfig.CRUDActions;

export function getShipmentManifests(opts = { start: 0, limit: 20 }) {
    return CRUDActions.getAll(actions.getAll, {
        ...opts,
        endpoint: endpoints.shipmentManifests,
        mapStructure: ShipmentManifest,
        errorNotification: "Manifestele de expediere nu au putut fi incarcate"
    });
}

export function getShipmentManifest(id) {
    return CRUDActions.getOne(actions.getOne, {
        id,
        endpoint: endpoints.shipmentManifest,
        mapStructure: ShipmentManifest,
        errorNotification: "Manifestul de expediere nu a putut fi incarcat"
    });
}
